/*
  首页页面相关api接口
 */
import request from './request';
export const indexApi = {
  /*
   首页交易区的market接口（专业版交易页面获取所有市场列表）
   数据结构为：
   [
    {
      name: "USDT",
      markets: [{...},{...}]
    }
   ]
    */
  getTradeArea() {
    return request({
      url: '/trade/market/list',
      method: 'get',
    });
  },
  /*
    获取所有市场列表
    数据结构为：
    [
      {symbol: "BTCUSDT",...},
      {symbol: "BTCUSDT",...},
      ...
   ]
   */
  get_TradingPairsAll_list() {
    return request({
      url: '/v2/s/market',
      method: 'get',
    });
  },

  /*
    获取热门交易数据
   */
  getHotDeal() {
    return request.get('/v2/s/market/topics');
  },
  /*
    获取k线数据
   */
  getkline(pair, interval, start, end) {
    return request({
      url: `/trade/list`,
      method: 'get',
      params: {
        pair,
        interval,
        start: start * 1000,
        end: end * 1000,
        filter: "100"
      },
    });
  },
  /*
    获取首页banner数据
   */
  getIndexBanner(params) {
    return request.get('/gw/w/support/web', {
      params,
    });
  },

  // TIP 注释描述：【首页信息】相关的接口
  homeIndex_supportApi: {
    // 尾部Footer信息
    get_footer() {
      return request({
        //      url: '/v2/s/trade/market/area',
        url: '/v2/s/support/footer',
        method: 'get',
      });
    },

    // 帮助中心Help-Center信息
    get_helpCenter() {
      return request({
        url: '/gw/w/support/help_center',
        method: 'get',
        // params: { categoryCode: 'HELP_CENTER' },
      });
    },

    // 导航栏Navigation信息
    getNavInfo() {
      return request({
        //      url: '/v2/s/trade/market/area',
        url: '/v2/s/support/nav',
        method: 'get',
      });
    },
    // 获取首页所有数据
    // 首页基本信息Web
    getWeb_IndexPageData() {
      return request({
        //      url: '/v2/s/trade/market/area',
        url: '/v2/s/support/web',
        method: 'get',
      });
    },
  },
};
